var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import * as ServiceAffaire from '../../services/affaire';
import { EditionAffaire } from './EditionAffaire';
import { Link } from '../../utils/Link';
import { Table } from '../../utils/Table';
import { AffaireIcon, CollaborateurIcon, ClientIcon } from '../../utils/Icons';
import { Chip } from '@mui/material';
import moment from 'moment';
import { formatNumber } from '../../services/utils/utils';
import { colorEtatAffaire } from '../../utils/Classes';
import { getOriginalUser } from '../../services/utilisateur';
import { converYearMonthToString } from '../../services/dashboard';
export var Affaire = function (props) {
    var originalUser = getOriginalUser();
    var _a = props.withFiltre, withFiltre = _a === void 0 ? false : _a, _b = props.ClientId, ClientId = _b === void 0 ? null : _b, _c = props.CollaborateurId, CollaborateurId = _c === void 0 ? null : _c, _d = props.CanAddAffaire, CanAddAffaire = _d === void 0 ? false : _d;
    var _e = useState([]), affaires = _e[0], setAffaires = _e[1];
    var _f = useState(0), total = _f[0], setTotal = _f[1];
    var getData = function (_a) {
        var _b = _a.page, page = _b === void 0 ? 1 : _b, _c = _a.itemByPage, itemByPage = _c === void 0 ? 10 : _c, _d = _a.filtres, filtres = _d === void 0 ? null : _d, _e = _a.order, order = _e === void 0 ? null : _e;
        return __awaiter(void 0, void 0, void 0, function () {
            var _f, Affaires, Total, error_1;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _g.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, ServiceAffaire.getAffaireListe(ClientId, CollaborateurId, {
                                page: page,
                                itemByPage: itemByPage,
                                filtres: filtres,
                                order: order,
                            })];
                    case 1:
                        _f = _g.sent(), Affaires = _f.Affaires, Total = _f.Total;
                        setAffaires(Affaires);
                        setTotal(Total);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _g.sent();
                        setAffaires([]);
                        setTotal(0);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    var displayClientPro = affaires.filter(function (c) { return c.IsSociete; }).length > 0;
    return (_jsx(_Fragment, { children: _jsx(Table, { title: !ClientId && !CollaborateurId ? 'Affaires' : '', color: "affaire", canEdit: ClientId && CanAddAffaire, renderModalEdition: function (handleClose, _a) {
                var _b = _a.AffaireId, AffaireId = _b === void 0 ? null : _b;
                return (_jsx(EditionAffaire, { ClientId: ClientId, AffaireId: AffaireId, handleClose: function () { return handleClose(); } }));
            }, onExport: originalUser.CanExportAffaire
                ? function (filtres) {
                    return ServiceAffaire.exportAffaire(ClientId, CollaborateurId, filtres);
                }
                : null, typeFiltre: withFiltre ? 'Affaire' : null, refresh: getData, total: total, isResponsive: true, headers: __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([
                {
                    label: 'Libelle',
                    component: function (value, _a) {
                        var color = _a.color;
                        return (_jsx(Link, { title: value.getLibelle, color: color, to: '/affaire/fiche/' + value.IdAffaire, icon: _jsx(AffaireIcon, {}), bold: true }));
                    },
                    orderBy: 'Libelle',
                },
                {
                    label: 'État',
                    align: 'center',
                    minWidth: true,
                    component: function (value) { return (_jsx(Chip, { color: colorEtatAffaire(value.Etat), label: value.getEtatLibelle })); },
                    orderBy: 'Etat',
                },
                {
                    label: 'Étape',
                    align: 'center',
                    minWidth: true,
                    component: function (value) {
                        return value.EtapeLibelle ? (_jsx(Chip, { color: colorEtatAffaire(value.Etat), label: value.EtapeLibelle })) : ('');
                    },
                    orderBy: 'Etape',
                }
            ], (!ClientId
                ? __spreadArray([
                    {
                        label: 'Client',
                        component: function (value) {
                            return value.client ? (_jsx(Link, { title: value.client.getLibelle, color: "client", to: '/client/fiche/' + value.client.IdClient, icon: _jsx(ClientIcon, {}) })) : ('-');
                        },
                    }
                ], (displayClientPro
                    ? [{ label: 'Siret', assessor: 'Siret', orderBy: 'Siret' }]
                    : []), true) : []), true), (originalUser.Licence.UseVision
                ? [
                    {
                        label: 'Collaborateur',
                        component: function (value) {
                            return value.collaborateur ? (_jsx(Link, { title: value.collaborateur.getLibelle, color: "collaborateur", to: '/collaborateur/fiche/' +
                                    value.collaborateur.IdCollaborateur, icon: _jsx(CollaborateurIcon, {}) })) : ('-');
                        },
                    },
                ]
                : []), true), (withFiltre
                ? [
                    {
                        label: 'Type',
                        assessor: 'affaire_type.Libelle',
                        orderBy: 'AffaireTypeId',
                    },
                ]
                : []), true), [
                {
                    label: 'Création',
                    minWidth: true,
                    component: function (value) {
                        return value.createdAt
                            ? moment(value.createdAt).format('DD/MM/YYYY')
                            : '';
                    },
                    orderBy: 'createdAt',
                },
                {
                    label: 'Signature',
                    minWidth: true,
                    component: function (value) {
                        return value.MoisSignature
                            ? converYearMonthToString(value.MoisSignature)
                            : '';
                    },
                    orderBy: 'MoisSignature',
                }
            ], false), (withFiltre
                ? [
                    {
                        label: 'Clôture',
                        align: 'right',
                        minWidth: true,
                        component: function (value) {
                            return value.DateCloture
                                ? moment(value.DateCloture).format('DD/MM/YYYY HH:mm')
                                : '';
                        },
                        orderBy: 'DateCloture',
                    },
                ]
                : []), true), [
                {
                    align: 'right',
                    label: 'Tarif',
                    component: function (value) { return formatNumber(value.TotalTarif, '€'); },
                    orderBy: 'TotalTarif',
                },
            ], false), datas: affaires ? affaires : [] }) }));
};
//# sourceMappingURL=Affaire.js.map